//
// Product Gallery functions
//
import { Fancybox, Carousel } from "@fancyapps/ui";
export default class ProductGallery {
  constructor() {
    const productGalleryCarouselElem = document.querySelector("#productGalleryCarousel");
    const productGalleryCarouselThumbElem = document.querySelector("#productGalleryThumbCarousel");

    // Initialise Product Carousel if present, else quit out now
    if (!productGalleryCarouselElem) return;

    const productGalleryCarousel = new Carousel(productGalleryCarouselElem, {
      Dots: false,
    });

    // Thumbnails (If more than one image is present)
    if (productGalleryCarouselThumbElem) {
      const productGalleryThumbCarousel = new Carousel(productGalleryCarouselThumbElem, {
        Sync: {
          target: productGalleryCarousel,
          friction: 0,
        },
        Dots: false,
        Navigation: false,
        center: true,
        slidesPerPage: 1,
        infinite: false,
      });
    }

    // Customize Fancybox
    Fancybox.bind('[data-fancybox="gallery"]', {
      Carousel: {
        on: {
          change: (that) => {
            productGalleryCarousel.slideTo(productGalleryCarousel.findPageForSlide(that.page), {
              friction: 0,
            });
          },
        },
      },
    });

  }
}